import { render, staticRenderFns } from "./foreign-visits.vue?vue&type=template&id=e60344b4&scoped=true"
import script from "./foreign-visits.vue?vue&type=script&lang=ts"
export * from "./foreign-visits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60344b4",
  null
  
)

export default component.exports